module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/QA-43bd22c5604656a0628e915757f38cda.png";